const API_BASE = process.env.REACT_APP_API_URL || 'https://4jbhzumjk7.execute-api.us-east-2.amazonaws.com/prod';

async function authFetch(path: string, token: string, options: RequestInit = {}) {
  const res = await fetch(`${API_BASE}${path}`, {
    ...options,
    headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json', ...options.headers },
  });
  if (!res.ok) {
    const data = await res.json().catch(() => ({}));
    if (data.requiresDisclaimer) throw Object.assign(new Error('disclaimer_required'), { requiresDisclaimer: true });
    throw new Error(data.error || `API error: ${res.status}`);
  }
  return res.json();
}

export interface LeaderTrade {
  tradeType: 'spread' | 'option' | 'stock';
  underlying: string;
  sellStrike?: number;
  buyStrike?: number;
  expiration?: string;
  entryPrice: number;
  exitPrice: number;
  pnl: number;
  openedAt?: string;
  closedAt?: string;
}

export interface TradeSummary {
  totalTrades: number;
  wins: number;
  losses: number;
  winRate: number;
  totalPnl: number;
  totalFees: number;
  avgPnl: number;
}

export async function getLeaderTrades(token: string, params?: { limit?: number }): Promise<{ trades: LeaderTrade[]; summary: TradeSummary }> {
  const query = new URLSearchParams();
  if (params?.limit) query.set('limit', String(params.limit));
  return authFetch(`/trade-with-me/trades?${query.toString()}`, token);
}
